import { createGenericDispatcher } from '../../action/action-dispatcher-factory';
import { stripeBasePlansStatusSelector } from '../account-selectors';

import { AccountApiClient } from '../../api/account-api-client';

export const getStripeBasePlans = () =>
  createGenericDispatcher({
    name: 'GET_STRIPE_BASE_PLANS',
    loadFunction: () => AccountApiClient.getBasePlans(),
    args: {},
    shouldExecuteSelector: (state: any) => stripeBasePlansStatusSelector(state),
  });
